import { UserDTO } from '@/generated';
import { Delete } from '@mui/icons-material';
import { Grid, Stack, Paper, Typography } from '@mui/material';
import { AccountType } from '@/models/user';

interface CardExerciseProps {
  timeout: number;
  user: UserDTO;
  onClick?: () => void;
}

const listPadding = 1;
const listGap = 0.5;

export const UserListElement = (props: CardExerciseProps & { setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>> }) => {
  const { user } = props;

  return (
    <Grid
      onClick={(e) => {
        if (props.onClick) props.onClick();
        e.stopPropagation();
      }}
      sx={{ cursor: 'pointer' }}
      size={{ xs: 12, md: 12 }}
    >
      <Stack
        onClick={(e) => {
          if (props.onClick) props.onClick();
        }}
        sx={{ justifyContent: 'flex-start', gap: listGap, mx: 2 }}
        direction={'row'}
      >
        {/* <Paper sx={{ p: listPadding, alignContent: 'center', alignItems: 'center' }} elevation={4}>
          <ImageFromServer sx={{ width: 30, height: 30 }} id={props.user.imageId} thumbnail={true} alt={''} />
        </Paper> */}
        <Paper sx={{ p: listPadding, alignContent: 'center', flex: 0.2 }} elevation={4}>
          <Stack sx={{ alignItems: 'center' }} gap={2} direction={'row'}>
            {user?.username}
          </Stack>
        </Paper>
        <Paper sx={{ p: listPadding, alignItems: 'center', alignContent: 'center', flex: 0.9 }} elevation={4}>
          <Stack direction={'row'}>
            <Stack sx={{ flex: 0.3, alignContent: 'center', alignItems: 'center' }} direction="row">
              <Typography variant="body2">Account Type: {AccountType[props.user.accountType]}</Typography>
            </Stack>
            <Stack sx={{ flex: 0.3, alignContent: 'center', alignItems: 'center' }} direction="row">
              <Typography variant="body2">Roles: {props.user?.roles.map((r) => r + ' ') || 'No Description'}</Typography>
            </Stack>
            <Stack sx={{ flex: 0.3, alignContent: 'center', alignItems: 'center' }} direction="row">
              <Typography variant="body2">Status: {props.user.active ? 'Active' : 'Inactive'}</Typography>
            </Stack>
            <Stack sx={{ flex: 0.2, flexDirection: 'row', justifyContent: 'flex-start' }}>
              <Typography sx={{ textAlign: 'start' }} variant="caption">
                Last login {user.lastLogin.toISOString()}
              </Typography>
            </Stack>
          </Stack>
        </Paper>

        <Paper
          onClick={(e) => {
            e.stopPropagation();
            props.setShowDeleteModal(true);
          }}
          sx={{ alignContent: 'center', textAlign: 'center', flex: 0.035 }}
          elevation={4}
        >
          {user && <Delete />}
        </Paper>
      </Stack>
    </Grid>
  );
};
